/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/

import * as thrift from "thrift";
import { Int64 } from "thrift";
import * as PContact from "./../../common/models";
import * as PColocation from "./../../common/models";
import * as PGmail from "./../../common/models";
import * as PTweet from "./../../common/models";
export interface IAppModificationArgs {
    newContact?: PContact.TAppContact;
    oldContact?: PContact.TAppContact;
    provenance?: PContact.TAppProvenance;
    notMyContact?: PContact.TAppContact;
    suspicious?: boolean;
    conflictsWith?: PContact.TAppContact;
}
export class AppModification {
    public newContact?: PContact.TAppContact;
    public oldContact?: PContact.TAppContact;
    public provenance?: PContact.TAppProvenance;
    public notMyContact?: PContact.TAppContact;
    public suspicious?: boolean;
    public conflictsWith?: PContact.TAppContact;
    constructor(args?: IAppModificationArgs) {
        if (args != null && args.newContact != null) {
            this.newContact = args.newContact;
        }
        if (args != null && args.oldContact != null) {
            this.oldContact = args.oldContact;
        }
        if (args != null && args.provenance != null) {
            this.provenance = args.provenance;
        }
        if (args != null && args.notMyContact != null) {
            this.notMyContact = args.notMyContact;
        }
        if (args != null && args.suspicious != null) {
            this.suspicious = args.suspicious;
        }
        if (args != null && args.conflictsWith != null) {
            this.conflictsWith = args.conflictsWith;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("AppModification");
        if (this.newContact != null) {
            output.writeFieldBegin("newContact", thrift.Thrift.Type.STRUCT, 1);
            this.newContact.write(output);
            output.writeFieldEnd();
        }
        if (this.oldContact != null) {
            output.writeFieldBegin("oldContact", thrift.Thrift.Type.STRUCT, 2);
            this.oldContact.write(output);
            output.writeFieldEnd();
        }
        if (this.provenance != null) {
            output.writeFieldBegin("provenance", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.provenance);
            output.writeFieldEnd();
        }
        if (this.notMyContact != null) {
            output.writeFieldBegin("notMyContact", thrift.Thrift.Type.STRUCT, 4);
            this.notMyContact.write(output);
            output.writeFieldEnd();
        }
        if (this.suspicious != null) {
            output.writeFieldBegin("suspicious", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.suspicious);
            output.writeFieldEnd();
        }
        if (this.conflictsWith != null) {
            output.writeFieldBegin("conflictsWith", thrift.Thrift.Type.STRUCT, 6);
            this.conflictsWith.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): AppModification {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_1: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.newContact = value_1;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_2: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.oldContact = value_2;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_3: PContact.TAppProvenance = input.readI32();
                        _args.provenance = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_4: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.notMyContact = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_5: boolean = input.readBool();
                        _args.suspicious = value_5;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_6: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.conflictsWith = value_6;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new AppModification(_args);
    }
}
export interface ITPushContactsRequestArgs {
    modifications: Array<AppModification>;
    hasMore: boolean;
}
export class TPushContactsRequest {
    public modifications: Array<AppModification>;
    public hasMore: boolean = false;
    constructor(args: ITPushContactsRequestArgs) {
        if (args != null && args.modifications != null) {
            this.modifications = args.modifications;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[modifications] is unset!");
        }
        if (args != null && args.hasMore != null) {
            this.hasMore = args.hasMore;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasMore] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TPushContactsRequest");
        if (this.modifications != null) {
            output.writeFieldBegin("modifications", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.modifications.length);
            this.modifications.forEach((value_7: AppModification): void => {
                value_7.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.hasMore != null) {
            output.writeFieldBegin("hasMore", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.hasMore);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TPushContactsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_8: Array<AppModification> = new Array<AppModification>();
                        const metadata_1: thrift.TList = input.readListBegin();
                        const size_1: number = metadata_1.size;
                        for (let i_1: number = 0; i_1 < size_1; i_1++) {
                            const value_9: AppModification = AppModification.read(input);
                            value_8.push(value_9);
                        }
                        input.readListEnd();
                        _args.modifications = value_8;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_10: boolean = input.readBool();
                        _args.hasMore = value_10;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.modifications !== undefined && _args.hasMore !== undefined) {
            return new TPushContactsRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TPushContactsRequest from input");
        }
    }
}
export interface ITPushContactsResponseArgs {
    receivedCount: number;
    acceptedCount: number;
    rejectedDuplicatesCount: number;
    invalidCount: number;
    rejectedContactIds?: Array<string>;
}
export class TPushContactsResponse {
    public receivedCount: number;
    public acceptedCount: number;
    public rejectedDuplicatesCount: number;
    public invalidCount: number;
    public rejectedContactIds?: Array<string>;
    constructor(args: ITPushContactsResponseArgs) {
        if (args != null && args.receivedCount != null) {
            this.receivedCount = args.receivedCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[receivedCount] is unset!");
        }
        if (args != null && args.acceptedCount != null) {
            this.acceptedCount = args.acceptedCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[acceptedCount] is unset!");
        }
        if (args != null && args.rejectedDuplicatesCount != null) {
            this.rejectedDuplicatesCount = args.rejectedDuplicatesCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[rejectedDuplicatesCount] is unset!");
        }
        if (args != null && args.invalidCount != null) {
            this.invalidCount = args.invalidCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[invalidCount] is unset!");
        }
        if (args != null && args.rejectedContactIds != null) {
            this.rejectedContactIds = args.rejectedContactIds;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TPushContactsResponse");
        if (this.receivedCount != null) {
            output.writeFieldBegin("receivedCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.receivedCount);
            output.writeFieldEnd();
        }
        if (this.acceptedCount != null) {
            output.writeFieldBegin("acceptedCount", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.acceptedCount);
            output.writeFieldEnd();
        }
        if (this.rejectedDuplicatesCount != null) {
            output.writeFieldBegin("rejectedDuplicatesCount", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.rejectedDuplicatesCount);
            output.writeFieldEnd();
        }
        if (this.invalidCount != null) {
            output.writeFieldBegin("invalidCount", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.invalidCount);
            output.writeFieldEnd();
        }
        if (this.rejectedContactIds != null) {
            output.writeFieldBegin("rejectedContactIds", thrift.Thrift.Type.LIST, 5);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.rejectedContactIds.length);
            this.rejectedContactIds.forEach((value_11: string): void => {
                output.writeString(value_11);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TPushContactsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_12: number = input.readI32();
                        _args.receivedCount = value_12;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_13: number = input.readI32();
                        _args.acceptedCount = value_13;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_14: number = input.readI32();
                        _args.rejectedDuplicatesCount = value_14;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_15: number = input.readI32();
                        _args.invalidCount = value_15;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_16: Array<string> = new Array<string>();
                        const metadata_2: thrift.TList = input.readListBegin();
                        const size_2: number = metadata_2.size;
                        for (let i_2: number = 0; i_2 < size_2; i_2++) {
                            const value_17: string = input.readString();
                            value_16.push(value_17);
                        }
                        input.readListEnd();
                        _args.rejectedContactIds = value_16;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.receivedCount !== undefined && _args.acceptedCount !== undefined && _args.rejectedDuplicatesCount !== undefined && _args.invalidCount !== undefined) {
            return new TPushContactsResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TPushContactsResponse from input");
        }
    }
}
export interface ITFetchContactsRequestArgs {
    clientModificationId?: string;
    maxPageSize?: number;
    bypassedContactIds?: Set<string>;
}
export class TFetchContactsRequest {
    public clientModificationId?: string;
    public maxPageSize?: number;
    public bypassedContactIds?: Set<string>;
    constructor(args?: ITFetchContactsRequestArgs) {
        if (args != null && args.clientModificationId != null) {
            this.clientModificationId = args.clientModificationId;
        }
        if (args != null && args.maxPageSize != null) {
            this.maxPageSize = args.maxPageSize;
        }
        if (args != null && args.bypassedContactIds != null) {
            this.bypassedContactIds = args.bypassedContactIds;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchContactsRequest");
        if (this.clientModificationId != null) {
            output.writeFieldBegin("clientModificationId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.clientModificationId);
            output.writeFieldEnd();
        }
        if (this.maxPageSize != null) {
            output.writeFieldBegin("maxPageSize", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.maxPageSize);
            output.writeFieldEnd();
        }
        if (this.bypassedContactIds != null) {
            output.writeFieldBegin("bypassedContactIds", thrift.Thrift.Type.SET, 3);
            output.writeSetBegin(thrift.Thrift.Type.STRING, this.bypassedContactIds.size);
            this.bypassedContactIds.forEach((value_18: string): void => {
                output.writeString(value_18);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchContactsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_19: string = input.readString();
                        _args.clientModificationId = value_19;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_20: number = input.readI32();
                        _args.maxPageSize = value_20;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_21: Set<string> = new Set<string>();
                        const metadata_3: thrift.TSet = input.readSetBegin();
                        const size_3: number = metadata_3.size;
                        for (let i_3: number = 0; i_3 < size_3; i_3++) {
                            const value_22: string = input.readString();
                            value_21.add(value_22);
                        }
                        input.readSetEnd();
                        _args.bypassedContactIds = value_21;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchContactsRequest(_args);
    }
}
export interface ITFetchContactsResponseArgs {
    contacts: Array<PContact.TAppContact>;
    deletedContactIds: Array<string>;
    oldToNewContactIdMap: Map<string, string>;
    newClientModificationId: string;
    readyToExport?: boolean;
}
export class TFetchContactsResponse {
    public contacts: Array<PContact.TAppContact>;
    public deletedContactIds: Array<string>;
    public oldToNewContactIdMap: Map<string, string>;
    public newClientModificationId: string;
    public readyToExport?: boolean;
    constructor(args: ITFetchContactsResponseArgs) {
        if (args != null && args.contacts != null) {
            this.contacts = args.contacts;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contacts] is unset!");
        }
        if (args != null && args.deletedContactIds != null) {
            this.deletedContactIds = args.deletedContactIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[deletedContactIds] is unset!");
        }
        if (args != null && args.oldToNewContactIdMap != null) {
            this.oldToNewContactIdMap = args.oldToNewContactIdMap;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[oldToNewContactIdMap] is unset!");
        }
        if (args != null && args.newClientModificationId != null) {
            this.newClientModificationId = args.newClientModificationId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[newClientModificationId] is unset!");
        }
        if (args != null && args.readyToExport != null) {
            this.readyToExport = args.readyToExport;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchContactsResponse");
        if (this.contacts != null) {
            output.writeFieldBegin("contacts", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.contacts.length);
            this.contacts.forEach((value_23: PContact.TAppContact): void => {
                value_23.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.deletedContactIds != null) {
            output.writeFieldBegin("deletedContactIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.deletedContactIds.length);
            this.deletedContactIds.forEach((value_24: string): void => {
                output.writeString(value_24);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.oldToNewContactIdMap != null) {
            output.writeFieldBegin("oldToNewContactIdMap", thrift.Thrift.Type.MAP, 3);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.STRING, this.oldToNewContactIdMap.size);
            this.oldToNewContactIdMap.forEach((value_25: string, key_1: string): void => {
                output.writeString(key_1);
                output.writeString(value_25);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.newClientModificationId != null) {
            output.writeFieldBegin("newClientModificationId", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.newClientModificationId);
            output.writeFieldEnd();
        }
        if (this.readyToExport != null) {
            output.writeFieldBegin("readyToExport", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.readyToExport);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchContactsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_26: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_4: thrift.TList = input.readListBegin();
                        const size_4: number = metadata_4.size;
                        for (let i_4: number = 0; i_4 < size_4; i_4++) {
                            const value_27: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_26.push(value_27);
                        }
                        input.readListEnd();
                        _args.contacts = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_28: Array<string> = new Array<string>();
                        const metadata_5: thrift.TList = input.readListBegin();
                        const size_5: number = metadata_5.size;
                        for (let i_5: number = 0; i_5 < size_5; i_5++) {
                            const value_29: string = input.readString();
                            value_28.push(value_29);
                        }
                        input.readListEnd();
                        _args.deletedContactIds = value_28;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_30: Map<string, string> = new Map<string, string>();
                        const metadata_6: thrift.TMap = input.readMapBegin();
                        const size_6: number = metadata_6.size;
                        for (let i_6: number = 0; i_6 < size_6; i_6++) {
                            const key_2: string = input.readString();
                            const value_31: string = input.readString();
                            value_30.set(key_2, value_31);
                        }
                        input.readMapEnd();
                        _args.oldToNewContactIdMap = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_32: string = input.readString();
                        _args.newClientModificationId = value_32;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_33: boolean = input.readBool();
                        _args.readyToExport = value_33;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contacts !== undefined && _args.deletedContactIds !== undefined && _args.oldToNewContactIdMap !== undefined && _args.newClientModificationId !== undefined) {
            return new TFetchContactsResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchContactsResponse from input");
        }
    }
}
export enum TFixThisCardType {
    UNDEFINED = 0,
    OTHER = 1,
    TYPO = 2,
    OBSOLETE = 3,
    WRONG_NAME = 4,
    BAD_MERGE = 5
}
export interface ITFixThisCardRequestArgs {
    contactView?: PContact.TAppContact;
    reporterNotes?: string;
    complaintType?: TFixThisCardType;
}
export class TFixThisCardRequest {
    public contactView?: PContact.TAppContact;
    public reporterNotes?: string;
    public complaintType?: TFixThisCardType;
    constructor(args?: ITFixThisCardRequestArgs) {
        if (args != null && args.contactView != null) {
            this.contactView = args.contactView;
        }
        if (args != null && args.reporterNotes != null) {
            this.reporterNotes = args.reporterNotes;
        }
        if (args != null && args.complaintType != null) {
            this.complaintType = args.complaintType;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFixThisCardRequest");
        if (this.contactView != null) {
            output.writeFieldBegin("contactView", thrift.Thrift.Type.STRUCT, 1);
            this.contactView.write(output);
            output.writeFieldEnd();
        }
        if (this.reporterNotes != null) {
            output.writeFieldBegin("reporterNotes", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.reporterNotes);
            output.writeFieldEnd();
        }
        if (this.complaintType != null) {
            output.writeFieldBegin("complaintType", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.complaintType);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFixThisCardRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_34: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contactView = value_34;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_35: string = input.readString();
                        _args.reporterNotes = value_35;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_36: TFixThisCardType = input.readI32();
                        _args.complaintType = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFixThisCardRequest(_args);
    }
}
export interface ITFixThisCardResponseArgs {
}
export class TFixThisCardResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFixThisCardResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFixThisCardResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFixThisCardResponse();
    }
}
export enum TAppUndoableActionType {
    LCM = 0
}
export interface ITGetContactDetailsRequestArgs {
    contactId: string;
}
export class TGetContactDetailsRequest {
    public contactId: string;
    constructor(args: ITGetContactDetailsRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetContactDetailsRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetContactDetailsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_37: string = input.readString();
                        _args.contactId = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined) {
            return new TGetContactDetailsRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetContactDetailsRequest from input");
        }
    }
}
export interface ITGetContactDetailsResponseArgs {
    latestColocation?: PColocation.TAppColocation;
    latestGmailMessage?: PGmail.TAppGmailMessage;
    latestTweet?: PTweet.TAppTweet;
    lastSeenOn?: Map<string, Int64>;
}
export class TGetContactDetailsResponse {
    public latestColocation?: PColocation.TAppColocation;
    public latestGmailMessage?: PGmail.TAppGmailMessage;
    public latestTweet?: PTweet.TAppTweet;
    public lastSeenOn?: Map<string, Int64>;
    constructor(args?: ITGetContactDetailsResponseArgs) {
        if (args != null && args.latestColocation != null) {
            this.latestColocation = args.latestColocation;
        }
        if (args != null && args.latestGmailMessage != null) {
            this.latestGmailMessage = args.latestGmailMessage;
        }
        if (args != null && args.latestTweet != null) {
            this.latestTweet = args.latestTweet;
        }
        if (args != null && args.lastSeenOn != null) {
            this.lastSeenOn = args.lastSeenOn;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetContactDetailsResponse");
        if (this.latestColocation != null) {
            output.writeFieldBegin("latestColocation", thrift.Thrift.Type.STRUCT, 1);
            this.latestColocation.write(output);
            output.writeFieldEnd();
        }
        if (this.latestGmailMessage != null) {
            output.writeFieldBegin("latestGmailMessage", thrift.Thrift.Type.STRUCT, 2);
            this.latestGmailMessage.write(output);
            output.writeFieldEnd();
        }
        if (this.latestTweet != null) {
            output.writeFieldBegin("latestTweet", thrift.Thrift.Type.STRUCT, 3);
            this.latestTweet.write(output);
            output.writeFieldEnd();
        }
        if (this.lastSeenOn != null) {
            output.writeFieldBegin("lastSeenOn", thrift.Thrift.Type.MAP, 4);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.I64, this.lastSeenOn.size);
            this.lastSeenOn.forEach((value_38: Int64, key_3: string): void => {
                output.writeString(key_3);
                output.writeI64(value_38);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetContactDetailsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_39: PColocation.TAppColocation = PColocation.TAppColocation.read(input);
                        _args.latestColocation = value_39;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_40: PGmail.TAppGmailMessage = PGmail.TAppGmailMessage.read(input);
                        _args.latestGmailMessage = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_41: PTweet.TAppTweet = PTweet.TAppTweet.read(input);
                        _args.latestTweet = value_41;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_42: Map<string, Int64> = new Map<string, Int64>();
                        const metadata_7: thrift.TMap = input.readMapBegin();
                        const size_7: number = metadata_7.size;
                        for (let i_7: number = 0; i_7 < size_7; i_7++) {
                            const key_4: string = input.readString();
                            const value_43: Int64 = input.readI64();
                            value_42.set(key_4, value_43);
                        }
                        input.readMapEnd();
                        _args.lastSeenOn = value_42;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TGetContactDetailsResponse(_args);
    }
}
export interface ITGetAnatomyOfContactRequestArgs {
    contactId: string;
}
export class TGetAnatomyOfContactRequest {
    public contactId: string;
    constructor(args: ITGetAnatomyOfContactRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetAnatomyOfContactRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetAnatomyOfContactRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_44: string = input.readString();
                        _args.contactId = value_44;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined) {
            return new TGetAnatomyOfContactRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetAnatomyOfContactRequest from input");
        }
    }
}
export interface ITGetAnatomyOfContactResponseArgs {
    provenanceFieldsMap?: Map<PContact.TAppProvenance, PContact.TAppContact>;
}
export class TGetAnatomyOfContactResponse {
    public provenanceFieldsMap?: Map<PContact.TAppProvenance, PContact.TAppContact>;
    constructor(args?: ITGetAnatomyOfContactResponseArgs) {
        if (args != null && args.provenanceFieldsMap != null) {
            this.provenanceFieldsMap = args.provenanceFieldsMap;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetAnatomyOfContactResponse");
        if (this.provenanceFieldsMap != null) {
            output.writeFieldBegin("provenanceFieldsMap", thrift.Thrift.Type.MAP, 1);
            output.writeMapBegin(thrift.Thrift.Type.I32, thrift.Thrift.Type.STRUCT, this.provenanceFieldsMap.size);
            this.provenanceFieldsMap.forEach((value_45: PContact.TAppContact, key_5: PContact.TAppProvenance): void => {
                output.writeI32(key_5);
                value_45.write(output);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetAnatomyOfContactResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_46: Map<PContact.TAppProvenance, PContact.TAppContact> = new Map<PContact.TAppProvenance, PContact.TAppContact>();
                        const metadata_8: thrift.TMap = input.readMapBegin();
                        const size_8: number = metadata_8.size;
                        for (let i_8: number = 0; i_8 < size_8; i_8++) {
                            const key_6: PContact.TAppProvenance = input.readI32();
                            const value_47: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_46.set(key_6, value_47);
                        }
                        input.readMapEnd();
                        _args.provenanceFieldsMap = value_46;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TGetAnatomyOfContactResponse(_args);
    }
}
export interface ITAppUndoableActionArgs {
    actionType: TAppUndoableActionType;
    actedTimestamp?: number | Int64;
}
export class TAppUndoableAction {
    public actionType: TAppUndoableActionType;
    public actedTimestamp?: Int64;
    constructor(args: ITAppUndoableActionArgs) {
        if (args != null && args.actionType != null) {
            this.actionType = args.actionType;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[actionType] is unset!");
        }
        if (args != null && args.actedTimestamp != null) {
            if (typeof args.actedTimestamp === "number") {
                this.actedTimestamp = new Int64(args.actedTimestamp);
            }
            else {
                this.actedTimestamp = args.actedTimestamp;
            }
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppUndoableAction");
        if (this.actionType != null) {
            output.writeFieldBegin("actionType", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.actionType);
            output.writeFieldEnd();
        }
        if (this.actedTimestamp != null) {
            output.writeFieldBegin("actedTimestamp", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.actedTimestamp);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppUndoableAction {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_48: TAppUndoableActionType = input.readI32();
                        _args.actionType = value_48;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_49: Int64 = input.readI64();
                        _args.actedTimestamp = value_49;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.actionType !== undefined) {
            return new TAppUndoableAction(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppUndoableAction from input");
        }
    }
}
export interface ITGetUndoableActionsForContactRequestArgs {
    contactId: string;
}
export class TGetUndoableActionsForContactRequest {
    public contactId: string;
    constructor(args: ITGetUndoableActionsForContactRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetUndoableActionsForContactRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetUndoableActionsForContactRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_50: string = input.readString();
                        _args.contactId = value_50;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined) {
            return new TGetUndoableActionsForContactRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetUndoableActionsForContactRequest from input");
        }
    }
}
export interface ITGetUndoableActionsForContactResponseArgs {
    actions?: Array<TAppUndoableAction>;
}
export class TGetUndoableActionsForContactResponse {
    public actions?: Array<TAppUndoableAction>;
    constructor(args?: ITGetUndoableActionsForContactResponseArgs) {
        if (args != null && args.actions != null) {
            this.actions = args.actions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetUndoableActionsForContactResponse");
        if (this.actions != null) {
            output.writeFieldBegin("actions", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.actions.length);
            this.actions.forEach((value_51: TAppUndoableAction): void => {
                value_51.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetUndoableActionsForContactResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_52: Array<TAppUndoableAction> = new Array<TAppUndoableAction>();
                        const metadata_9: thrift.TList = input.readListBegin();
                        const size_9: number = metadata_9.size;
                        for (let i_9: number = 0; i_9 < size_9; i_9++) {
                            const value_53: TAppUndoableAction = TAppUndoableAction.read(input);
                            value_52.push(value_53);
                        }
                        input.readListEnd();
                        _args.actions = value_52;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TGetUndoableActionsForContactResponse(_args);
    }
}
export enum TMergeAcceptance {
    NO = 0,
    YES = 1,
    UNSURE = 2
}
export interface ITUpdateSuggestedMergeRequestArgs {
    includedContactIds: Array<string>;
    acceptance: TMergeAcceptance;
    preferredFields?: PContact.TAppContact;
    associatedContactIds?: Map<string, Set<string>>;
}
export class TUpdateSuggestedMergeRequest {
    public includedContactIds: Array<string>;
    public acceptance: TMergeAcceptance;
    public preferredFields?: PContact.TAppContact;
    public associatedContactIds?: Map<string, Set<string>>;
    constructor(args: ITUpdateSuggestedMergeRequestArgs) {
        if (args != null && args.includedContactIds != null) {
            this.includedContactIds = args.includedContactIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[includedContactIds] is unset!");
        }
        if (args != null && args.acceptance != null) {
            this.acceptance = args.acceptance;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[acceptance] is unset!");
        }
        if (args != null && args.preferredFields != null) {
            this.preferredFields = args.preferredFields;
        }
        if (args != null && args.associatedContactIds != null) {
            this.associatedContactIds = args.associatedContactIds;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateSuggestedMergeRequest");
        if (this.includedContactIds != null) {
            output.writeFieldBegin("includedContactIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.includedContactIds.length);
            this.includedContactIds.forEach((value_54: string): void => {
                output.writeString(value_54);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.acceptance != null) {
            output.writeFieldBegin("acceptance", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.acceptance);
            output.writeFieldEnd();
        }
        if (this.preferredFields != null) {
            output.writeFieldBegin("preferredFields", thrift.Thrift.Type.STRUCT, 3);
            this.preferredFields.write(output);
            output.writeFieldEnd();
        }
        if (this.associatedContactIds != null) {
            output.writeFieldBegin("associatedContactIds", thrift.Thrift.Type.MAP, 4);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.SET, this.associatedContactIds.size);
            this.associatedContactIds.forEach((value_55: Set<string>, key_7: string): void => {
                output.writeString(key_7);
                output.writeSetBegin(thrift.Thrift.Type.STRING, value_55.size);
                value_55.forEach((value_56: string): void => {
                    output.writeString(value_56);
                });
                output.writeSetEnd();
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateSuggestedMergeRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_57: Array<string> = new Array<string>();
                        const metadata_10: thrift.TList = input.readListBegin();
                        const size_10: number = metadata_10.size;
                        for (let i_10: number = 0; i_10 < size_10; i_10++) {
                            const value_58: string = input.readString();
                            value_57.push(value_58);
                        }
                        input.readListEnd();
                        _args.includedContactIds = value_57;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_59: TMergeAcceptance = input.readI32();
                        _args.acceptance = value_59;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_60: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.preferredFields = value_60;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_61: Map<string, Set<string>> = new Map<string, Set<string>>();
                        const metadata_11: thrift.TMap = input.readMapBegin();
                        const size_11: number = metadata_11.size;
                        for (let i_11: number = 0; i_11 < size_11; i_11++) {
                            const key_8: string = input.readString();
                            const value_62: Set<string> = new Set<string>();
                            const metadata_12: thrift.TSet = input.readSetBegin();
                            const size_12: number = metadata_12.size;
                            for (let i_12: number = 0; i_12 < size_12; i_12++) {
                                const value_63: string = input.readString();
                                value_62.add(value_63);
                            }
                            input.readSetEnd();
                            value_61.set(key_8, value_62);
                        }
                        input.readMapEnd();
                        _args.associatedContactIds = value_61;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.includedContactIds !== undefined && _args.acceptance !== undefined) {
            return new TUpdateSuggestedMergeRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateSuggestedMergeRequest from input");
        }
    }
}
export interface ITUpdateSuggestedMergeResponseArgs {
    success: boolean;
}
export class TUpdateSuggestedMergeResponse {
    public success: boolean;
    constructor(args: ITUpdateSuggestedMergeResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateSuggestedMergeResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateSuggestedMergeResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_64: boolean = input.readBool();
                        _args.success = value_64;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TUpdateSuggestedMergeResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateSuggestedMergeResponse from input");
        }
    }
}
export interface ITUpdateSuggestedMergesRequestArgs {
    mergeRequests: Array<TUpdateSuggestedMergeRequest>;
}
export class TUpdateSuggestedMergesRequest {
    public mergeRequests: Array<TUpdateSuggestedMergeRequest>;
    constructor(args: ITUpdateSuggestedMergesRequestArgs) {
        if (args != null && args.mergeRequests != null) {
            this.mergeRequests = args.mergeRequests;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[mergeRequests] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateSuggestedMergesRequest");
        if (this.mergeRequests != null) {
            output.writeFieldBegin("mergeRequests", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.mergeRequests.length);
            this.mergeRequests.forEach((value_65: TUpdateSuggestedMergeRequest): void => {
                value_65.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateSuggestedMergesRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_66: Array<TUpdateSuggestedMergeRequest> = new Array<TUpdateSuggestedMergeRequest>();
                        const metadata_13: thrift.TList = input.readListBegin();
                        const size_13: number = metadata_13.size;
                        for (let i_13: number = 0; i_13 < size_13; i_13++) {
                            const value_67: TUpdateSuggestedMergeRequest = TUpdateSuggestedMergeRequest.read(input);
                            value_66.push(value_67);
                        }
                        input.readListEnd();
                        _args.mergeRequests = value_66;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.mergeRequests !== undefined) {
            return new TUpdateSuggestedMergesRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateSuggestedMergesRequest from input");
        }
    }
}
export interface ITUpdateSuggestedMergesResponseArgs {
    success: boolean;
}
export class TUpdateSuggestedMergesResponse {
    public success: boolean;
    constructor(args: ITUpdateSuggestedMergesResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateSuggestedMergesResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateSuggestedMergesResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_68: boolean = input.readBool();
                        _args.success = value_68;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TUpdateSuggestedMergesResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateSuggestedMergesResponse from input");
        }
    }
}
export interface ITUndoSuggestedMergeRequestArgs {
    contacts: Array<PContact.TAppContact>;
}
export class TUndoSuggestedMergeRequest {
    public contacts: Array<PContact.TAppContact>;
    constructor(args: ITUndoSuggestedMergeRequestArgs) {
        if (args != null && args.contacts != null) {
            this.contacts = args.contacts;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contacts] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUndoSuggestedMergeRequest");
        if (this.contacts != null) {
            output.writeFieldBegin("contacts", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.contacts.length);
            this.contacts.forEach((value_69: PContact.TAppContact): void => {
                value_69.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUndoSuggestedMergeRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_70: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_14: thrift.TList = input.readListBegin();
                        const size_14: number = metadata_14.size;
                        for (let i_14: number = 0; i_14 < size_14; i_14++) {
                            const value_71: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_70.push(value_71);
                        }
                        input.readListEnd();
                        _args.contacts = value_70;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contacts !== undefined) {
            return new TUndoSuggestedMergeRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUndoSuggestedMergeRequest from input");
        }
    }
}
export interface ITUndoSuggestedMergeResponseArgs {
    success: boolean;
}
export class TUndoSuggestedMergeResponse {
    public success: boolean;
    constructor(args: ITUndoSuggestedMergeResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[success] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUndoSuggestedMergeResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUndoSuggestedMergeResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_72: boolean = input.readBool();
                        _args.success = value_72;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.success !== undefined) {
            return new TUndoSuggestedMergeResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUndoSuggestedMergeResponse from input");
        }
    }
}
export interface ITEnsureSyncedRequestArgs {
    contactIds: Array<string>;
    clientModificationId?: string;
    originalContactIdMap?: Map<string, Array<PContact.TAppContactId>>;
    serverEditSequenceIdMap?: Map<string, string>;
    maxPageSize?: number;
}
export class TEnsureSyncedRequest {
    public contactIds: Array<string>;
    public clientModificationId?: string;
    public originalContactIdMap?: Map<string, Array<PContact.TAppContactId>>;
    public serverEditSequenceIdMap?: Map<string, string>;
    public maxPageSize?: number;
    constructor(args: ITEnsureSyncedRequestArgs) {
        if (args != null && args.contactIds != null) {
            this.contactIds = args.contactIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactIds] is unset!");
        }
        if (args != null && args.clientModificationId != null) {
            this.clientModificationId = args.clientModificationId;
        }
        if (args != null && args.originalContactIdMap != null) {
            this.originalContactIdMap = args.originalContactIdMap;
        }
        if (args != null && args.serverEditSequenceIdMap != null) {
            this.serverEditSequenceIdMap = args.serverEditSequenceIdMap;
        }
        if (args != null && args.maxPageSize != null) {
            this.maxPageSize = args.maxPageSize;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TEnsureSyncedRequest");
        if (this.contactIds != null) {
            output.writeFieldBegin("contactIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.contactIds.length);
            this.contactIds.forEach((value_73: string): void => {
                output.writeString(value_73);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.clientModificationId != null) {
            output.writeFieldBegin("clientModificationId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.clientModificationId);
            output.writeFieldEnd();
        }
        if (this.originalContactIdMap != null) {
            output.writeFieldBegin("originalContactIdMap", thrift.Thrift.Type.MAP, 3);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.LIST, this.originalContactIdMap.size);
            this.originalContactIdMap.forEach((value_74: Array<PContact.TAppContactId>, key_9: string): void => {
                output.writeString(key_9);
                output.writeListBegin(thrift.Thrift.Type.STRUCT, value_74.length);
                value_74.forEach((value_75: PContact.TAppContactId): void => {
                    value_75.write(output);
                });
                output.writeListEnd();
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.serverEditSequenceIdMap != null) {
            output.writeFieldBegin("serverEditSequenceIdMap", thrift.Thrift.Type.MAP, 4);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.STRING, this.serverEditSequenceIdMap.size);
            this.serverEditSequenceIdMap.forEach((value_76: string, key_10: string): void => {
                output.writeString(key_10);
                output.writeString(value_76);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.maxPageSize != null) {
            output.writeFieldBegin("maxPageSize", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.maxPageSize);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TEnsureSyncedRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_77: Array<string> = new Array<string>();
                        const metadata_15: thrift.TList = input.readListBegin();
                        const size_15: number = metadata_15.size;
                        for (let i_15: number = 0; i_15 < size_15; i_15++) {
                            const value_78: string = input.readString();
                            value_77.push(value_78);
                        }
                        input.readListEnd();
                        _args.contactIds = value_77;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_79: string = input.readString();
                        _args.clientModificationId = value_79;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_80: Map<string, Array<PContact.TAppContactId>> = new Map<string, Array<PContact.TAppContactId>>();
                        const metadata_16: thrift.TMap = input.readMapBegin();
                        const size_16: number = metadata_16.size;
                        for (let i_16: number = 0; i_16 < size_16; i_16++) {
                            const key_11: string = input.readString();
                            const value_81: Array<PContact.TAppContactId> = new Array<PContact.TAppContactId>();
                            const metadata_17: thrift.TList = input.readListBegin();
                            const size_17: number = metadata_17.size;
                            for (let i_17: number = 0; i_17 < size_17; i_17++) {
                                const value_82: PContact.TAppContactId = PContact.TAppContactId.read(input);
                                value_81.push(value_82);
                            }
                            input.readListEnd();
                            value_80.set(key_11, value_81);
                        }
                        input.readMapEnd();
                        _args.originalContactIdMap = value_80;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_83: Map<string, string> = new Map<string, string>();
                        const metadata_18: thrift.TMap = input.readMapBegin();
                        const size_18: number = metadata_18.size;
                        for (let i_18: number = 0; i_18 < size_18; i_18++) {
                            const key_12: string = input.readString();
                            const value_84: string = input.readString();
                            value_83.set(key_12, value_84);
                        }
                        input.readMapEnd();
                        _args.serverEditSequenceIdMap = value_83;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_85: number = input.readI32();
                        _args.maxPageSize = value_85;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactIds !== undefined) {
            return new TEnsureSyncedRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TEnsureSyncedRequest from input");
        }
    }
}
export interface ITEnsureSyncedResponseArgs {
    unrecognizedContactIds: Array<string>;
    upsertContacts?: Array<PContact.TAppContact>;
    hasMore?: boolean;
}
export class TEnsureSyncedResponse {
    public unrecognizedContactIds: Array<string>;
    public upsertContacts?: Array<PContact.TAppContact>;
    public hasMore?: boolean;
    constructor(args: ITEnsureSyncedResponseArgs) {
        if (args != null && args.unrecognizedContactIds != null) {
            this.unrecognizedContactIds = args.unrecognizedContactIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[unrecognizedContactIds] is unset!");
        }
        if (args != null && args.upsertContacts != null) {
            this.upsertContacts = args.upsertContacts;
        }
        if (args != null && args.hasMore != null) {
            this.hasMore = args.hasMore;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TEnsureSyncedResponse");
        if (this.unrecognizedContactIds != null) {
            output.writeFieldBegin("unrecognizedContactIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.unrecognizedContactIds.length);
            this.unrecognizedContactIds.forEach((value_86: string): void => {
                output.writeString(value_86);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.upsertContacts != null) {
            output.writeFieldBegin("upsertContacts", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.upsertContacts.length);
            this.upsertContacts.forEach((value_87: PContact.TAppContact): void => {
                value_87.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.hasMore != null) {
            output.writeFieldBegin("hasMore", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.hasMore);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TEnsureSyncedResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_88: Array<string> = new Array<string>();
                        const metadata_19: thrift.TList = input.readListBegin();
                        const size_19: number = metadata_19.size;
                        for (let i_19: number = 0; i_19 < size_19; i_19++) {
                            const value_89: string = input.readString();
                            value_88.push(value_89);
                        }
                        input.readListEnd();
                        _args.unrecognizedContactIds = value_88;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_90: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_20: thrift.TList = input.readListBegin();
                        const size_20: number = metadata_20.size;
                        for (let i_20: number = 0; i_20 < size_20; i_20++) {
                            const value_91: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_90.push(value_91);
                        }
                        input.readListEnd();
                        _args.upsertContacts = value_90;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_92: boolean = input.readBool();
                        _args.hasMore = value_92;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.unrecognizedContactIds !== undefined) {
            return new TEnsureSyncedResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TEnsureSyncedResponse from input");
        }
    }
}
export interface ITFetchAdditionalSelfContactInfoRequestArgs {
    userEnteredSelfContact?: PContact.TAppContact;
    importedSelfContact?: PContact.TAppContact;
    potentialSelfContacts?: Array<PContact.TAppContact>;
}
export class TFetchAdditionalSelfContactInfoRequest {
    public userEnteredSelfContact?: PContact.TAppContact;
    public importedSelfContact?: PContact.TAppContact;
    public potentialSelfContacts?: Array<PContact.TAppContact>;
    constructor(args?: ITFetchAdditionalSelfContactInfoRequestArgs) {
        if (args != null && args.userEnteredSelfContact != null) {
            this.userEnteredSelfContact = args.userEnteredSelfContact;
        }
        if (args != null && args.importedSelfContact != null) {
            this.importedSelfContact = args.importedSelfContact;
        }
        if (args != null && args.potentialSelfContacts != null) {
            this.potentialSelfContacts = args.potentialSelfContacts;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAdditionalSelfContactInfoRequest");
        if (this.userEnteredSelfContact != null) {
            output.writeFieldBegin("userEnteredSelfContact", thrift.Thrift.Type.STRUCT, 1);
            this.userEnteredSelfContact.write(output);
            output.writeFieldEnd();
        }
        if (this.importedSelfContact != null) {
            output.writeFieldBegin("importedSelfContact", thrift.Thrift.Type.STRUCT, 2);
            this.importedSelfContact.write(output);
            output.writeFieldEnd();
        }
        if (this.potentialSelfContacts != null) {
            output.writeFieldBegin("potentialSelfContacts", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.potentialSelfContacts.length);
            this.potentialSelfContacts.forEach((value_93: PContact.TAppContact): void => {
                value_93.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAdditionalSelfContactInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_94: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.userEnteredSelfContact = value_94;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_95: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.importedSelfContact = value_95;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_96: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_21: thrift.TList = input.readListBegin();
                        const size_21: number = metadata_21.size;
                        for (let i_21: number = 0; i_21 < size_21; i_21++) {
                            const value_97: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_96.push(value_97);
                        }
                        input.readListEnd();
                        _args.potentialSelfContacts = value_96;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchAdditionalSelfContactInfoRequest(_args);
    }
}
export interface ITFetchAdditionalSelfContactInfoResponseArgs {
    userEnteredSelfContact?: PContact.TAppContact;
    contactInfoToConfirm?: PContact.TAppContact;
}
export class TFetchAdditionalSelfContactInfoResponse {
    public userEnteredSelfContact?: PContact.TAppContact;
    public contactInfoToConfirm?: PContact.TAppContact;
    constructor(args?: ITFetchAdditionalSelfContactInfoResponseArgs) {
        if (args != null && args.userEnteredSelfContact != null) {
            this.userEnteredSelfContact = args.userEnteredSelfContact;
        }
        if (args != null && args.contactInfoToConfirm != null) {
            this.contactInfoToConfirm = args.contactInfoToConfirm;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAdditionalSelfContactInfoResponse");
        if (this.userEnteredSelfContact != null) {
            output.writeFieldBegin("userEnteredSelfContact", thrift.Thrift.Type.STRUCT, 1);
            this.userEnteredSelfContact.write(output);
            output.writeFieldEnd();
        }
        if (this.contactInfoToConfirm != null) {
            output.writeFieldBegin("contactInfoToConfirm", thrift.Thrift.Type.STRUCT, 2);
            this.contactInfoToConfirm.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAdditionalSelfContactInfoResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_98: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.userEnteredSelfContact = value_98;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_99: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contactInfoToConfirm = value_99;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchAdditionalSelfContactInfoResponse(_args);
    }
}
export interface ITFetchOriginalContactsRequestArgs {
    contactIds: Array<string>;
    provenances?: Array<PContact.TAppProvenance>;
}
export class TFetchOriginalContactsRequest {
    public contactIds: Array<string>;
    public provenances?: Array<PContact.TAppProvenance>;
    constructor(args: ITFetchOriginalContactsRequestArgs) {
        if (args != null && args.contactIds != null) {
            this.contactIds = args.contactIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactIds] is unset!");
        }
        if (args != null && args.provenances != null) {
            this.provenances = args.provenances;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchOriginalContactsRequest");
        if (this.contactIds != null) {
            output.writeFieldBegin("contactIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.contactIds.length);
            this.contactIds.forEach((value_100: string): void => {
                output.writeString(value_100);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.provenances != null) {
            output.writeFieldBegin("provenances", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.I32, this.provenances.length);
            this.provenances.forEach((value_101: PContact.TAppProvenance): void => {
                output.writeI32(value_101);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchOriginalContactsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_102: Array<string> = new Array<string>();
                        const metadata_22: thrift.TList = input.readListBegin();
                        const size_22: number = metadata_22.size;
                        for (let i_22: number = 0; i_22 < size_22; i_22++) {
                            const value_103: string = input.readString();
                            value_102.push(value_103);
                        }
                        input.readListEnd();
                        _args.contactIds = value_102;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_104: Array<PContact.TAppProvenance> = new Array<PContact.TAppProvenance>();
                        const metadata_23: thrift.TList = input.readListBegin();
                        const size_23: number = metadata_23.size;
                        for (let i_23: number = 0; i_23 < size_23; i_23++) {
                            const value_105: PContact.TAppProvenance = input.readI32();
                            value_104.push(value_105);
                        }
                        input.readListEnd();
                        _args.provenances = value_104;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactIds !== undefined) {
            return new TFetchOriginalContactsRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchOriginalContactsRequest from input");
        }
    }
}
export interface ITFetchOriginalContactsResponseArgs {
    contacts?: Array<PContact.TAppContact>;
}
export class TFetchOriginalContactsResponse {
    public contacts?: Array<PContact.TAppContact>;
    constructor(args?: ITFetchOriginalContactsResponseArgs) {
        if (args != null && args.contacts != null) {
            this.contacts = args.contacts;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchOriginalContactsResponse");
        if (this.contacts != null) {
            output.writeFieldBegin("contacts", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.contacts.length);
            this.contacts.forEach((value_106: PContact.TAppContact): void => {
                value_106.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchOriginalContactsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_107: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_24: thrift.TList = input.readListBegin();
                        const size_24: number = metadata_24.size;
                        for (let i_24: number = 0; i_24 < size_24; i_24++) {
                            const value_108: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_107.push(value_108);
                        }
                        input.readListEnd();
                        _args.contacts = value_107;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchOriginalContactsResponse(_args);
    }
}
export interface ITUndoMergeRequestArgs {
    contactId?: string;
    originalContactIds?: Array<PContact.TAppContactId>;
}
export class TUndoMergeRequest {
    public contactId?: string;
    public originalContactIds?: Array<PContact.TAppContactId>;
    constructor(args?: ITUndoMergeRequestArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        if (args != null && args.originalContactIds != null) {
            this.originalContactIds = args.originalContactIds;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUndoMergeRequest");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.originalContactIds != null) {
            output.writeFieldBegin("originalContactIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.originalContactIds.length);
            this.originalContactIds.forEach((value_109: PContact.TAppContactId): void => {
                value_109.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUndoMergeRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_110: string = input.readString();
                        _args.contactId = value_110;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_111: Array<PContact.TAppContactId> = new Array<PContact.TAppContactId>();
                        const metadata_25: thrift.TList = input.readListBegin();
                        const size_25: number = metadata_25.size;
                        for (let i_25: number = 0; i_25 < size_25; i_25++) {
                            const value_112: PContact.TAppContactId = PContact.TAppContactId.read(input);
                            value_111.push(value_112);
                        }
                        input.readListEnd();
                        _args.originalContactIds = value_111;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUndoMergeRequest(_args);
    }
}
export interface ITUndoMergeResponseArgs {
    success?: boolean;
}
export class TUndoMergeResponse {
    public success?: boolean;
    constructor(args?: ITUndoMergeResponseArgs) {
        if (args != null && args.success != null) {
            this.success = args.success;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUndoMergeResponse");
        if (this.success != null) {
            output.writeFieldBegin("success", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.success);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUndoMergeResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_113: boolean = input.readBool();
                        _args.success = value_113;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUndoMergeResponse(_args);
    }
}
export enum TContactsSinceBackupMode {
    ADDS = 0,
    EDITS = 1
}
export interface ITContactsSinceBackupRequestArgs {
    containerId: string;
    mode: TContactsSinceBackupMode;
    maxPageSize: number;
    page: number;
    originalContactIds?: Array<string>;
}
export class TContactsSinceBackupRequest {
    public containerId: string;
    public mode: TContactsSinceBackupMode;
    public maxPageSize: number;
    public page: number;
    public originalContactIds?: Array<string>;
    constructor(args: ITContactsSinceBackupRequestArgs) {
        if (args != null && args.containerId != null) {
            this.containerId = args.containerId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[containerId] is unset!");
        }
        if (args != null && args.mode != null) {
            this.mode = args.mode;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[mode] is unset!");
        }
        if (args != null && args.maxPageSize != null) {
            this.maxPageSize = args.maxPageSize;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[maxPageSize] is unset!");
        }
        if (args != null && args.page != null) {
            this.page = args.page;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[page] is unset!");
        }
        if (args != null && args.originalContactIds != null) {
            this.originalContactIds = args.originalContactIds;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TContactsSinceBackupRequest");
        if (this.containerId != null) {
            output.writeFieldBegin("containerId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.containerId);
            output.writeFieldEnd();
        }
        if (this.mode != null) {
            output.writeFieldBegin("mode", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.mode);
            output.writeFieldEnd();
        }
        if (this.maxPageSize != null) {
            output.writeFieldBegin("maxPageSize", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.maxPageSize);
            output.writeFieldEnd();
        }
        if (this.page != null) {
            output.writeFieldBegin("page", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.page);
            output.writeFieldEnd();
        }
        if (this.originalContactIds != null) {
            output.writeFieldBegin("originalContactIds", thrift.Thrift.Type.LIST, 5);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.originalContactIds.length);
            this.originalContactIds.forEach((value_114: string): void => {
                output.writeString(value_114);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TContactsSinceBackupRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_115: string = input.readString();
                        _args.containerId = value_115;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_116: TContactsSinceBackupMode = input.readI32();
                        _args.mode = value_116;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_117: number = input.readI32();
                        _args.maxPageSize = value_117;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_118: number = input.readI32();
                        _args.page = value_118;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_119: Array<string> = new Array<string>();
                        const metadata_26: thrift.TList = input.readListBegin();
                        const size_26: number = metadata_26.size;
                        for (let i_26: number = 0; i_26 < size_26; i_26++) {
                            const value_120: string = input.readString();
                            value_119.push(value_120);
                        }
                        input.readListEnd();
                        _args.originalContactIds = value_119;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.containerId !== undefined && _args.mode !== undefined && _args.maxPageSize !== undefined && _args.page !== undefined) {
            return new TContactsSinceBackupRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TContactsSinceBackupRequest from input");
        }
    }
}
export interface ITContactsSinceBackupResponseArgs {
    adds?: Array<PContact.TAppContact>;
    deletes?: Array<PContact.TAppContact>;
    hasNextPage?: boolean;
}
export class TContactsSinceBackupResponse {
    public adds?: Array<PContact.TAppContact>;
    public deletes?: Array<PContact.TAppContact>;
    public hasNextPage?: boolean;
    constructor(args?: ITContactsSinceBackupResponseArgs) {
        if (args != null && args.adds != null) {
            this.adds = args.adds;
        }
        if (args != null && args.deletes != null) {
            this.deletes = args.deletes;
        }
        if (args != null && args.hasNextPage != null) {
            this.hasNextPage = args.hasNextPage;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TContactsSinceBackupResponse");
        if (this.adds != null) {
            output.writeFieldBegin("adds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.adds.length);
            this.adds.forEach((value_121: PContact.TAppContact): void => {
                value_121.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.deletes != null) {
            output.writeFieldBegin("deletes", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.deletes.length);
            this.deletes.forEach((value_122: PContact.TAppContact): void => {
                value_122.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.hasNextPage != null) {
            output.writeFieldBegin("hasNextPage", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.hasNextPage);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TContactsSinceBackupResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_123: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_27: thrift.TList = input.readListBegin();
                        const size_27: number = metadata_27.size;
                        for (let i_27: number = 0; i_27 < size_27; i_27++) {
                            const value_124: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_123.push(value_124);
                        }
                        input.readListEnd();
                        _args.adds = value_123;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_125: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_28: thrift.TList = input.readListBegin();
                        const size_28: number = metadata_28.size;
                        for (let i_28: number = 0; i_28 < size_28; i_28++) {
                            const value_126: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_125.push(value_126);
                        }
                        input.readListEnd();
                        _args.deletes = value_125;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_127: boolean = input.readBool();
                        _args.hasNextPage = value_127;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TContactsSinceBackupResponse(_args);
    }
}
